export type AppEnv = "local" | "recette" | "production";

const rawEnv = (import.meta.env.VITE_APP_ENV ?? "local") as AppEnv;

export const appEnv: AppEnv =
  rawEnv === "local" || rawEnv === "recette" || rawEnv === "production" ? rawEnv : "local";

export const apiUrl: string = import.meta.env.VITE_API_URL ?? "/api";
export const siteUrl: string = import.meta.env.VITE_SITE_URL ?? "";

export const isProduction = appEnv === "production";
export const isRecette = appEnv === "recette";
export const isLocal = appEnv === "local";
